import {MARQUES_ROUTES as marqueRoutes, PRODUIT_ROUTES as produitRoutes} from "~/api/routes";
import vue from "vue";

export const state = () => ({
  produits: [],
  produitDraft: {},
  details:null,
  close: false,
  marque: null,
});

export const getters = {
  products: state => state.produits,
  productsOptions: state => state.produits.map(p => {
    return{
      value: p,
      text: p.nom_affichage,
    }
  }),
  close: state => state.close,
};

export const mutations = {
  LOAD_PRODUITS(state, produits)
  {
    state.produits = produits;
  },
  PRODUIT_SUCCES(state,details) {
    state.details = details;
  },
  ADD_PRODUIT(state, produit) {
    state.produits.unshift(produit);
  },
  UPDATE_PRODUIT(state, produit) {
    state.produits = state.produits.map(p =>{
      if (p.article_id === produit.id)
        return  produit.data;
      return p;
    });
  },
  RESET_ORDER(state){
    state.produits =  state.produits.map((p, i) =>{
      p.order = i + 1;
      return p ;
    })
  },
  DELETE_PRODUIT(state, article_id) {
   state.produits = state.produits.filter(p=>{
     return !(p.article_id === article_id);
   });
  },
  TOGGLE_NEW(state, params) {
   state.produits = state.produits.map(p=>{
     if (p.article_id == params.article_id)
       p.new = params.new;
     return p;
   });
  },
  CHANGE_VISIBLE(state, params) {
   state.produits = state.produits.map(p=>{
     if (p.article_id === params.id)
       p.visible = params.visible;
     return p;
   });
  }, UPDATE_ORDER(state, params) {
    state.produits = params;
  },
  CLOSE_MODAL(state, params){
    state.close = params;
  },
};

export const actions = {
  async getProduits({ commit }) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.list)
        .then(response => {
          commit('LOAD_PRODUITS', response.payload);
          resolve();
        })
        .catch(error => {
        });
    });
  },
  // ADD NEW PRODUCT
  async createProduit({ commit }, params) {
    commit('CLOSE_MODAL', false);
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.create, {}, params.formData)
        .then(response => {
          commit('ADD_PRODUIT', response.payload);
          commit('CLOSE_MODAL', true);
          resolve();
        })
        .catch(error => {
          commit('CLOSE_MODAL', false);
          reject(error);
        });
    });
  },
  // GET SPECIFEC PRODUCT
  async getProduit({commit}, params) {
    await this.$api.request(produitRoutes.get,{id:params.article_id})
      .then(response => {
        commit('PRODUIT_SUCCES', response.payload);

      })
      .catch(error => {
      });
  },
  // UPDATE A PRODUIT
  async updateProduit({ commit }, params) {
    commit('CLOSE_MODAL', false);
    return new Promise((resolve, reject) =>{
      this.$api.request(produitRoutes.update, { id: params.id }, params.formData)
        .then(response => {
          commit('UPDATE_PRODUIT', {data: response.payload, id: params.id});
          // commit('CLOSE_MODAL', true);
          resolve();
        })
        .catch(error => {
          commit('CLOSE_MODAL', false);
          reject(error);
        });
    })

  },
  // DELETE A PRODUUIT
  async deleteProduit({ commit }, params) {
    await this.$api.request(produitRoutes.delete, { id: params.article_id })
      .then(response => {
        commit('DELETE_PRODUIT', params.article_id);
      })
      .catch(error => {
      });
  },
  async changeVisible({ commit }, params) {
    await this.$api.request(produitRoutes.publier, { id: params.id}, {value: params.visible})
      .then(response => {
        commit('CHANGE_VISIBLE', params)
      })
      .catch(error => {
      });

  },
  async toggleNew({ commit }, article_id) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.new, { id: article_id},)
        .then(res => {
          commit('TOGGLE_NEW', res.payload);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async updateOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      //ADD REQUEST TO API HERE
      this.$api.request(marqueRoutes.order, { id: params.marque_id}, {position: params.order, produit_id: params.id})
        .then(response => {
          commit('UPDATE_ORDER', params.list);
          commit('RESET_ORDER');
          resolve();
        })
        .catch(error => {
          reject()
        });
      setTimeout(() =>{
        resolve();
      }, 1000);
    });
  },
  async updateIndex({ commit }, params) {
    return new Promise((resolve, reject) => {
      //ADD REQUEST TO API HERE
      this.$api.request(marqueRoutes.order, { id: params.marque_id}, {position: params.order, produit_id: params.id})
        .then(response => {
          resolve();
        })
        .catch(error => {
        });
      setTimeout(() =>{
        resolve();
      }, 1000);
    });
  },
  getProduitsToBeValidated({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.draft.list)
        .then(response => {
          commit('LOAD_PRODUITS', response.payload);
          resolve();
        }).catch(error => {
          console.log(error);
          reject();
        });
    });
  },
  getProduitDraft({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.draft.get, {id: params.id})
        .then(response => {
          resolve(response.payload);
        }).catch(error => {
          console.log(error);
          reject();
        });
    });
  },
  togglePublish({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.draft.togglePublish, {id: params.id})
        .then((response) => {
          resolve(response);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  validateDraft({ commit }, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(produitRoutes.draft.validate, { id: params.article_id}, {valid: params.valid})
        .then((response) => {
          commit('CLOSE_MODAL', true);
          resolve(response);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  closeModal({ commit }, params) {
    commit('CLOSE_MODAL', true);
  },
};
